import React, { Fragment } from 'react';
import './Resources.scss';
import Boost from '../../components/Boost/index';

// IMAGES
import conversation from '../../images/illustration-flowing-conversation.svg';

export default function Resources() {
  return (
    <Fragment>
      <header className='resources-header'>
        <img
          className='resources-header__img'
          src={conversation}
          alt='people interacting with screens'
        />
        <div className='resources-header__text'>
          <h1 className='resources-header__h1'>Learn & grow with your users</h1>
          <h2 className='resources-header__h2'>
            We've curated some of our best resources to help you grow your
            brand.
          </h2>

          <a href='#resources'>
            <button className='btn'>Get Started</button>
          </a>
        </div>
      </header>

      <main className='resources'>
        <div className='resources__heading-container' id='resources'>
          <h3>Digging Deeper</h3>
          <p>
            Make your business stronger by taking advantage of our in-depth
            resources.
          </p>
        </div>

        <div className='resources__containers'>
          <div className='resources__container first-container'>
            <div className='resources__icon-bg'>
              <i className='fas fa-book-reader'></i>
            </div>
            <h4 className='resources__heading'>Case Study</h4>
            <p className='resources__title'>
              Increase Engagement by 10% With Targeted Keywords
            </p>
            <button className='btn not-active'>View for Free</button>
          </div>
          <div className='container__line'></div>
          <div className='wrapper'>
            <div className='resources__container second-container'>
              <div className='resources__icon-bg'>
                <i className='fas fa-desktop'></i>
              </div>
              <h4 className='resources__heading'>Webinar</h4>
              <p className='resources__title'>
                5 Steps to Refining Your User Profiles
              </p>
              <button className='btn not-active'>View Free Demo</button>
            </div>
          </div>
          <div className='container__line'></div>

          <div className='resources__container third-container'>
            <div className='resources__icon-bg'>
              <i className='fas fa-video'></i>
            </div>
            <h4 className='resources__heading'>Video Course</h4>
            <p className='resources__title'>
              Increase Engagement by 10% With Targeted Keywords
            </p>
            <button className='btn not-active'>Enroll for Free</button>
          </div>
        </div>
      </main>

      <Boost />
    </Fragment>
  );
}
